<script setup lang="ts">
import { type Ref, ref, watchEffect } from 'vue';

import { useI18n } from 'vue-i18n';

import customCompsetStatus from '@/config/customCompsetStatus';
import type { CompsetStatusConfig, CompsetAvailableStatusNames } from '@/declarations/customCompsets';

interface TagConfig extends Pick<CompsetStatusConfig, 'color' | 'text'> {
  show: boolean,
}

type TagConfigList = Array<TagConfig>

const props = defineProps<{
  status: CompsetAvailableStatusNames,
  isProcessing?: boolean,
}>();

const { t } = useI18n();

const tags: Ref<TagConfigList> = ref([]);

watchEffect(() => {
  const { text, color } = customCompsetStatus[props.status];

  tags.value = [
    { text, color, show: true },
    {
      text: 'Processing',
      color: 'primary',
      show: !!props.isProcessing,
    },
  ];
});
</script>

<template>
  <div class="inline-flex items-center gap-4">
    <template
      v-for="tag in tags"
    >
      <LpTag
        v-if="tag.show"
        :key="tag.text"
        :color="tag.color"
        size="big"
      >
        <span
          data-testid="tag"
          class="text-sm text-base-900"
        >
          {{ t(tag.text) }}
        </span>
      </LpTag>
    </template>
  </div>
</template>
